const TiposBoleto = [
    { cod: "tp-ticket-programado", descricao: "TP - TICKET PROGRAMADO" },
    { cod: "ta-dedicado-5g-movel", descricao: "TA - DEDICADO *SITE 5G MÓVEL*" },
    // { cod: "ta-dedicado-bbnv2", descricao: "TA - DEDICADO BBN-V-2" },
    // { cod: "ta-dedicado-bbnv1", descricao: "TA - DEDICADO BBN-V-1" },
    // { cod: "ta-dedicado-bbnv2-dwdm", descricao: "TA - DEDICADO *BBN-V-2* DWDM" },
    // { cod: "ta-dedicado-bbnv1-dwdm", descricao: "TA - DEDICADO *BBN-V-1* DWDM" },
    { cod: "bbn-dwdm-fspo", descricao: "BBN - DWDM FSPO" },
    { cod: "bbn-dwdm-dspo", descricao: "BBN - DWDM DSPO" },
    { cod: "bd-sigtm-b2b", descricao: "BD - SIGTM (B2B)" },
    { cod: "tq-ticket-qualidade", descricao: "TQ - TICKET QUALIDADE" },
    { cod: "ta-ticket-anormalidade-geral", descricao: "TA - TICKET DE ANORMALIDADE (GERAL)" }
  ];

  export default TiposBoleto